// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutKontaktRouteImport } from './routes/_layout/kontakt'
import { Route as LayoutPartnerRouteImport } from './routes/_layout/partner'
import { Route as LayoutTestErrorRouteImport } from './routes/_layout/test-error'
import { Route as ObsahKontaktRouteImport } from './routes/obsah/kontakt'
import { Route as ObsahPartnerRouteImport } from './routes/obsah/partner'
import { Route as LayoutInspiraceIndexRouteImport } from './routes/_layout/inspirace/index'
import { Route as LayoutInspiraceSlugRouteImport } from './routes/_layout/inspirace/$slug'
import { Route as LayoutObjednavkaOrderNumberRouteImport } from './routes/_layout/objednavka/$orderNumber'
import { Route as LayoutPobytyIndexRouteImport } from './routes/_layout/pobyty/index'
import { Route as LayoutUbytovaniIndexRouteImport } from './routes/_layout/ubytovani/index'
import { Route as LayoutUbytovaniHledatRouteImport } from './routes/_layout/ubytovani/hledat'
import { Route as CardLocationSlugRouteImport } from './routes/card.location.$slug'
import { Route as CardOfferOfferIdRouteImport } from './routes/card.offer.$offerId'
import { Route as CardUnitUnitIdRouteImport } from './routes/card.unit.$unitId'
import { Route as UbytovaniSlugDetailRouteImport } from './routes/ubytovani/$slug/detail'
import { Route as LayoutHodnoceniOrderNumberTokenRouteImport } from './routes/_layout/hodnoceni/$orderNumber/$token'
import { Route as LayoutLocationWatchmanUnsubscribeTokenRouteImport } from './routes/_layout/location-watchman/unsubscribe/$token'
import { Route as LayoutPobytyLandingSlugIndexRouteImport } from './routes/_layout/pobyty/$landingSlug/index'
import { Route as LayoutPobytyLandingSlugComboSlugRouteImport } from './routes/_layout/pobyty/$landingSlug/$comboSlug'
import { Route as LayoutUbytovaniSlugIndexRouteImport } from './routes/_layout/ubytovani/$slug/index'
import { Route as LayoutUbytovaniSlugGalerieRouteImport } from './routes/_layout/ubytovani/$slug/galerie'
import { Route as LayoutUbytovaniSlugPotvrzeniRouteImport } from './routes/_layout/ubytovani/$slug/potvrzeni'
import { Route as LayoutUbytovaniSlugRezervaceRouteImport } from './routes/_layout/ubytovani/$slug/rezervace'
import { Route as LayoutZadostOrderNumberTokenRouteImport } from './routes/_layout/zadost/$orderNumber/$token'
import { Route as LayoutUbytovaniSlugUnitSlugIndexRouteImport } from './routes/_layout/ubytovani/$slug/$unitSlug/index'
import { Route as LayoutUbytovaniSlugUnitSlugGalerieRouteImport } from './routes/_layout/ubytovani/$slug/$unitSlug/galerie'
import { Route as LayoutUbytovaniSlugUnitSlugPotvrzeniRouteImport } from './routes/_layout/ubytovani/$slug/$unitSlug/potvrzeni'
import { Route as LayoutUbytovaniSlugUnitSlugRezervaceRouteImport } from './routes/_layout/ubytovani/$slug/$unitSlug/rezervace'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          })
const LayoutKontaktRoute = LayoutKontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => LayoutRoute
          })
const LayoutPartnerRoute = LayoutPartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => LayoutRoute
          })
const LayoutTestErrorRoute = LayoutTestErrorRouteImport.update({
            id: '/test-error',path: '/test-error',getParentRoute: () => LayoutRoute
          })
const ObsahKontaktRoute = ObsahKontaktRouteImport.update({
            id: '/obsah/kontakt',path: '/obsah/kontakt',getParentRoute: () => rootRouteImport
          })
const ObsahPartnerRoute = ObsahPartnerRouteImport.update({
            id: '/obsah/partner',path: '/obsah/partner',getParentRoute: () => rootRouteImport
          })
const LayoutInspiraceIndexRoute = LayoutInspiraceIndexRouteImport.update({
            id: '/inspirace/',path: '/inspirace/',getParentRoute: () => LayoutRoute
          })
const LayoutInspiraceSlugRoute = LayoutInspiraceSlugRouteImport.update({
            id: '/inspirace/$slug',path: '/inspirace/$slug',getParentRoute: () => LayoutRoute
          })
const LayoutObjednavkaOrderNumberRoute = LayoutObjednavkaOrderNumberRouteImport.update({
            id: '/objednavka/$orderNumber',path: '/objednavka/$orderNumber',getParentRoute: () => LayoutRoute
          })
const LayoutPobytyIndexRoute = LayoutPobytyIndexRouteImport.update({
            id: '/pobyty/',path: '/pobyty/',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniIndexRoute = LayoutUbytovaniIndexRouteImport.update({
            id: '/ubytovani/',path: '/ubytovani/',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniHledatRoute = LayoutUbytovaniHledatRouteImport.update({
            id: '/ubytovani/hledat',path: '/ubytovani/hledat',getParentRoute: () => LayoutRoute
          })
const CardLocationSlugRoute = CardLocationSlugRouteImport.update({
            id: '/card/location/$slug',path: '/card/location/$slug',getParentRoute: () => rootRouteImport
          })
const CardOfferOfferIdRoute = CardOfferOfferIdRouteImport.update({
            id: '/card/offer/$offerId',path: '/card/offer/$offerId',getParentRoute: () => rootRouteImport
          })
const CardUnitUnitIdRoute = CardUnitUnitIdRouteImport.update({
            id: '/card/unit/$unitId',path: '/card/unit/$unitId',getParentRoute: () => rootRouteImport
          })
const UbytovaniSlugDetailRoute = UbytovaniSlugDetailRouteImport.update({
            id: '/ubytovani/$slug/detail',path: '/ubytovani/$slug/detail',getParentRoute: () => rootRouteImport
          })
const LayoutHodnoceniOrderNumberTokenRoute = LayoutHodnoceniOrderNumberTokenRouteImport.update({
            id: '/hodnoceni/$orderNumber/$token',path: '/hodnoceni/$orderNumber/$token',getParentRoute: () => LayoutRoute
          })
const LayoutLocationWatchmanUnsubscribeTokenRoute = LayoutLocationWatchmanUnsubscribeTokenRouteImport.update({
            id: '/location-watchman/unsubscribe/$token',path: '/location-watchman/unsubscribe/$token',getParentRoute: () => LayoutRoute
          })
const LayoutPobytyLandingSlugIndexRoute = LayoutPobytyLandingSlugIndexRouteImport.update({
            id: '/pobyty/$landingSlug/',path: '/pobyty/$landingSlug/',getParentRoute: () => LayoutRoute
          })
const LayoutPobytyLandingSlugComboSlugRoute = LayoutPobytyLandingSlugComboSlugRouteImport.update({
            id: '/pobyty/$landingSlug/$comboSlug',path: '/pobyty/$landingSlug/$comboSlug',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugIndexRoute = LayoutUbytovaniSlugIndexRouteImport.update({
            id: '/ubytovani/$slug/',path: '/ubytovani/$slug/',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugGalerieRoute = LayoutUbytovaniSlugGalerieRouteImport.update({
            id: '/ubytovani/$slug/galerie',path: '/ubytovani/$slug/galerie',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugPotvrzeniRoute = LayoutUbytovaniSlugPotvrzeniRouteImport.update({
            id: '/ubytovani/$slug/potvrzeni',path: '/ubytovani/$slug/potvrzeni',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugRezervaceRoute = LayoutUbytovaniSlugRezervaceRouteImport.update({
            id: '/ubytovani/$slug/rezervace',path: '/ubytovani/$slug/rezervace',getParentRoute: () => LayoutRoute
          })
const LayoutZadostOrderNumberTokenRoute = LayoutZadostOrderNumberTokenRouteImport.update({
            id: '/zadost/$orderNumber/$token',path: '/zadost/$orderNumber/$token',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugUnitSlugIndexRoute = LayoutUbytovaniSlugUnitSlugIndexRouteImport.update({
            id: '/ubytovani/$slug/$unitSlug/',path: '/ubytovani/$slug/$unitSlug/',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugUnitSlugGalerieRoute = LayoutUbytovaniSlugUnitSlugGalerieRouteImport.update({
            id: '/ubytovani/$slug/$unitSlug/galerie',path: '/ubytovani/$slug/$unitSlug/galerie',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugUnitSlugPotvrzeniRoute = LayoutUbytovaniSlugUnitSlugPotvrzeniRouteImport.update({
            id: '/ubytovani/$slug/$unitSlug/potvrzeni',path: '/ubytovani/$slug/$unitSlug/potvrzeni',getParentRoute: () => LayoutRoute
          })
const LayoutUbytovaniSlugUnitSlugRezervaceRoute = LayoutUbytovaniSlugUnitSlugRezervaceRouteImport.update({
            id: '/ubytovani/$slug/$unitSlug/rezervace',path: '/ubytovani/$slug/$unitSlug/rezervace',getParentRoute: () => LayoutRoute
          })





const LayoutRouteChildren = {
  LayoutKontaktRoute: LayoutKontaktRoute,LayoutPartnerRoute: LayoutPartnerRoute,LayoutTestErrorRoute: LayoutTestErrorRoute,LayoutInspiraceSlugRoute: LayoutInspiraceSlugRoute,LayoutObjednavkaOrderNumberRoute: LayoutObjednavkaOrderNumberRoute,LayoutUbytovaniHledatRoute: LayoutUbytovaniHledatRoute,LayoutInspiraceIndexRoute: LayoutInspiraceIndexRoute,LayoutPobytyIndexRoute: LayoutPobytyIndexRoute,LayoutUbytovaniIndexRoute: LayoutUbytovaniIndexRoute,LayoutHodnoceniOrderNumberTokenRoute: LayoutHodnoceniOrderNumberTokenRoute,LayoutLocationWatchmanUnsubscribeTokenRoute: LayoutLocationWatchmanUnsubscribeTokenRoute,LayoutPobytyLandingSlugComboSlugRoute: LayoutPobytyLandingSlugComboSlugRoute,LayoutUbytovaniSlugGalerieRoute: LayoutUbytovaniSlugGalerieRoute,LayoutUbytovaniSlugPotvrzeniRoute: LayoutUbytovaniSlugPotvrzeniRoute,LayoutUbytovaniSlugRezervaceRoute: LayoutUbytovaniSlugRezervaceRoute,LayoutZadostOrderNumberTokenRoute: LayoutZadostOrderNumberTokenRoute,LayoutPobytyLandingSlugIndexRoute: LayoutPobytyLandingSlugIndexRoute,LayoutUbytovaniSlugIndexRoute: LayoutUbytovaniSlugIndexRoute,LayoutUbytovaniSlugUnitSlugGalerieRoute: LayoutUbytovaniSlugUnitSlugGalerieRoute,LayoutUbytovaniSlugUnitSlugPotvrzeniRoute: LayoutUbytovaniSlugUnitSlugPotvrzeniRoute,LayoutUbytovaniSlugUnitSlugRezervaceRoute: LayoutUbytovaniSlugUnitSlugRezervaceRoute,LayoutUbytovaniSlugUnitSlugIndexRoute: LayoutUbytovaniSlugUnitSlugIndexRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LayoutRoute: LayoutRouteWithChildren,ObsahKontaktRoute: ObsahKontaktRoute,ObsahPartnerRoute: ObsahPartnerRoute,CardLocationSlugRoute: CardLocationSlugRoute,CardOfferOfferIdRoute: CardOfferOfferIdRoute,CardUnitUnitIdRoute: CardUnitUnitIdRoute,UbytovaniSlugDetailRoute: UbytovaniSlugDetailRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)